import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import axios from "axios";
import { useLocation } from "react-router-dom";
import FeedCard from "../components/FeedCard";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function SearchResultsPage() {
  const query = useQuery();
  const searchTerm = query.get("query") || "";

  const [items, setItems] = useState([]);
  const currentUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (!searchTerm || !currentUser?.id) return;

    const fetchResults = async () => {
      try {
        const res = await axios.get(
          `http://localhost:5000/search?query=${encodeURIComponent(
            searchTerm
          )}&userId=${currentUser.id}`
        );

        // Combine user + post results into HomeFeed-like format
        const formatted = res.data.results
          .filter((r) => r.resultType === "post") // only posts for FeedCard
          .map((p) => ({
            id: p.id,
            userId: p.userId,
            username: p.username,
            avatar: p.avatar,
            activity: p.activity,
            notes: p.notes,
            photo: p.photo,
            location: p.location,
            distance: p.distance,
            createdAt: p.createdAt,
          }));

        setItems(formatted);
      } catch (err) {
        console.error("❌ Search error:", err);
      }
    };

    fetchResults();
  }, [searchTerm, currentUser]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
        Search results for: "{searchTerm}"
      </Typography>

      {items.length === 0 ? (
        <Typography color="text.secondary">No moments found.</Typography>
      ) : (
        items.map((item) => <FeedCard key={item.id} item={item} />)
      )}
    </Box>
  );
}

export default SearchResultsPage;
